import wtaLogo from "@/assets/wta-logo.png";

const Footer = () => {
  return (
    <footer className="py-12 border-t border-gold/10">
      <div className="container mx-auto px-6 md:px-12 text-center space-y-5">
        <img
          src={wtaLogo}
          alt="Wealth Transfer Academy Logo"
          className="w-24 h-24 object-contain mx-auto drop-shadow-[0_0_20px_hsl(43_72%_55%_/_0.25)]"
        />
        <p className="font-display text-lg text-gradient-gold font-semibold tracking-wide">
          Wealth Transfer Academy
        </p>
        <p className="text-muted-foreground font-body text-xs tracking-wider">
          © {new Date().getFullYear()} Angela Joseph Roberson. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
